import React from 'react'

export const PrinterSpecificLandingPage = React.lazy(() =>
  import('./Landing/Specific/PrinterSpecificLandingPage')
)
export const InstallDriversLandingPage = React.lazy(() =>
  import('./Landing/InstallDrivers/InstallDriversLandingPage')
)
export const CarouselPage = React.lazy(() =>
  import('./Instructions/CarouselPage')
)
export const ConnectUsbPage = React.lazy(() =>
  import('./SetupChecklist/ConnectUsbPage')
)
export const UnsupportedOsPage = React.lazy(() => import('./UnsupportedOsPage'))
export const InstallDriverPage = React.lazy(() =>
  import('./SetupChecklist/InstallDriverPage')
)
export const DownloadingDriverPage = React.lazy(() =>
  import('./SetupChecklist/DownloadingDriverPage')
)
export const DriverNotFoundPage = React.lazy(() =>
  import('./SetupChecklist/DriverNotFoundPage')
)
export const DriverSuccessPage = React.lazy(() =>
  import('./SetupChecklist/DriverSuccessPage')
)
export const SelectUsbOnDisplayPage = React.lazy(() =>
  import('./SetupChecklist/SelectUsbOnDisplayPage')
)
export const NotFoundPage = React.lazy(() =>
  import('./Landing/NotFoundPage/NotFoundPage')
)
export const DeltaCodePage = React.lazy(() => import('./DeltaCodePage'))
export const HpSoftwarePage = React.lazy(() => import('./HpSoftwarePage'))
export const StartAirprintPage = React.lazy(() => import('./StartAirprintPage'))
export const SidebarOptionPage = React.lazy(() =>
  import('./SidebarOptionPage/SidebarOptionPage')
)
export const InstallPage = React.lazy(() => import('./install/InstallPage'))
export const SearchPage = React.lazy(() =>
  import('./Landing/SearchPrinter/SearchPrinter')
)
export const SimpleLandingPage = React.lazy(() =>
  import('./Landing/Simple/SimpleLandingPage')
)
